import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ContentSelectorModule } from '@app/collections-constructor/components';
import { CategoriesItemComponent } from '@app/library/panes/categories-content-filter/categories-item/categories-item.component';
import { LibraryPanesModule } from '@app/library/panes/library-panes.module';
import { MeetingReviewFormComponent } from '@app/library/panes/meeting-review-form/meeting-review-form.component';
import { SchoolFormModule } from '@app/school-settings/school-form/school-form.module';
import { AlertModule } from '@core/components/alert/alert.module';
import { BookmarkComponent } from '@core/components/bookmark/bookmark.component';
import { EmptyComponent } from '@core/components/empty/empty.component';
import { MediaFileSelectorModule } from '@core/components/media-file-selector/media-file-selector.module';
import { MeetingFormWrapperModule } from '@core/components/meeting-form-wrapper/meeting-form-wrapper.module';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { PaginationModule } from '@core/components/pagination/pagination.module';
import { TitleModule } from '@core/components/title/title.module';
import { PipesModule } from '@core/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { ComplaintFormModule } from '@shared/complaint-form/complaint-form.module';
import { IconComponent } from '@shared/icon/icon.component';
import { RatingComponent } from '@shared/rating/rating.component';
import { SkeletonComponent } from '@shared/skeleton/skeleton.component';
import { Lingo2FormsModule } from 'lingo2-forms';
import { ClipboardModule } from 'ngx-clipboard';
import { OnUiButtonModule, OnUiCardMenuModule, OnUiCoverModule } from 'onclass-ui';
import { SchoolClassesModule } from '../school-classes/school-classes.module';
import { SchoolFeedModule } from '../school-feed/school-feed.module';
import { SchoolHeaderComponent } from '../school-header/school-header.component';
import { SchoolPageComponent } from '../school-page/school-page.component';

@NgModule({
  declarations: [SchoolPageComponent, SchoolHeaderComponent],
  imports: [
    AlertModule,
    CategoriesItemComponent,
    CommonModule,
    ContentSelectorModule,
    IconComponent,
    LibraryPanesModule,
    Lingo2FormsModule,
    MediaFileSelectorModule,
    MobileModalModule,
    ModalModule,
    OnUiButtonModule,
    PaginationModule,
    RouterModule,
    SchoolClassesModule,
    SchoolFeedModule,
    SchoolFormModule,
    TitleModule,
    TranslateModule,
    EmptyComponent,
    OnUiCoverModule,
    BookmarkComponent,
    OnUiCardMenuModule,
    ClipboardModule,
    ComplaintFormModule,
    MeetingFormWrapperModule,
    SkeletonComponent,
    PipesModule,
    RatingComponent,
    MeetingReviewFormComponent,
  ],
  exports: [SchoolPageComponent],
})
export class SchoolPageModule {}
